import { useContext, useEffect, useState } from "react";
import { DatePicker } from "react-advance-jalaali-datepicker";
import FormFooter from "../../components/FormFooter";
import { MyContext } from "../../context/myContext";
import moment from "moment-jalaali";
import { useDispatch, useSelector } from "react-redux";
import {
  selectShowForm,
  selectRegisterBtnType,
  selectAllCities,
} from "../common-states/commonStatesSlice";
import {
  addOrEditNomad,
  selectInputsState,
  selectSelectsState,
} from "./applicantSlice";
import axios from "axios";

const AddApplicantForm = () => {
  const { nomadId, setNomadId } = useContext(MyContext);
  const initialInputState = {
    fatherName: "",
    name: "",
    birthday: "",
    code: "",
    phone: "",
    mobile: "",
    distance: "",
    family: "",
    insuredLiveStock: "",
    liveStock: "",
    nomadicArea: "",
    waterVolume: "",
    membershipNumber: "",
    requestTankerDays: 0,
    waterType: "",
  };
  const initialSelectsState = {
    city: "",
    province: "خراسان جنوبی",
    tank: "",
    registrationType: "",
  };
  const [inputs, setInputs] = useState(initialInputState);
  const [selects, setSelects] = useState(initialSelectsState);
  const [insurances, setInsurances] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingInsurances, setIsLoadingInsurances] = useState(false);

  const dispatch = useDispatch();
  const registerBtnType = useSelector(selectRegisterBtnType);
  const showForm = useSelector(selectShowForm);
  const inputsState = useSelector(selectInputsState);
  const selectsState = useSelector(selectSelectsState);
  const allCities = useSelector(selectAllCities);

  useEffect(() => {
    if (inputsState !== null && selectsState !== null) {
      setInputs(inputsState);
      setSelects(selectsState);
    }
  }, [inputsState, selectsState]);

  useEffect(() => {
    if (nomadId) {
      fetchInsurances(nomadId);
    } else {
      setInsurances([]);
    }
  }, [nomadId]);

  const fetchInsurances = async (nomadId) => {
    setIsLoadingInsurances(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `https://api.khedmatashayer-kj.ir/v1/nomad/insurance?nomad_id=${nomadId}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        },
      );
      if (response.status === 200 && response.data) {
        const insuranceList = response.data.map((item) => ({
          insurance_id: item.insurance_id,
          expiry: moment(item.expiry_date, "YYYY-MM-DD").format("jYYYY/jMM/jDD"),
          file: null,
          existingImage: item.image || null,
          isNew: false,
        }));
        setInsurances(insuranceList);
      }
    } catch (error) {
      console.error("خطا در دریافت بیمه‌نامه‌ها:", error);
    } finally {
      setIsLoadingInsurances(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };
  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setSelects((prev) => ({ ...prev, [name]: value }));
  };
  const handleDateChange = (timestamp, newDate) => {
    setInputs((prev) => ({ ...prev, birthday: newDate }));
  };

  const addInsurance = () => {
    setInsurances((prev) => [
      ...prev,
      { id: Date.now() + Math.random(), expiry: "", file: null, isNew: true, existingImage: null },
    ]);
  };

  const removeInsurance = (id) => {
    setInsurances((prev) => prev.filter((item) => (item.id || item.insurance_id) !== id));
  };

  const handleInsuranceDateChange = (id, newDate) => {
    setInsurances((prev) =>
      prev.map((item) => {
        const key = item.id || item.insurance_id;
        if (key === id) {
          return { ...item, expiry: newDate };
        }
        return item;
      }),
    );
  };

  const handleInsuranceFileChange = (id, file) => {
    setInsurances((prev) =>
      prev.map((item) => {
        const key = item.id || item.insurance_id;
        if (key === id) {
          return { ...item, file, existingImage: null };
        }
        return item;
      }),
    );
  };

  const sendInsurances = async (nomadId) => {
    const token = localStorage.getItem("token");
    const errors = [];
    let successCount = 0;

    for (const insurance of insurances) {
      const key = insurance.id || insurance.insurance_id;
      if (insurance.isNew && (!insurance.expiry || !insurance.file)) {
        errors.push(`بیمه‌نامه جدید فاقد تاریخ یا فایل است`);
        continue;
      }
      if (!insurance.isNew && !insurance.expiry) {
        errors.push(`بیمه‌نامه با شناسه ${insurance.insurance_id} فاقد تاریخ است`);
        continue;
      }

      const formData = new FormData();
      formData.append("nomad", nomadId);
      const expiryDate = moment(insurance.expiry, "jYYYY/jM/jDD").format("YYYY/MM/DD");
      formData.append("expiry_date", expiryDate);
      if (insurance.file) {
        formData.append("image", insurance.file);
      }

      try {
        if (insurance.isNew) {
          await axios.post(
            `https://api.khedmatashayer-kj.ir/v1/nomad/insurance`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
              },
            },
          );
        } else {
          await axios.put(
            `https://api.khedmatashayer-kj.ir/v1/nomad/insurance/${insurance.insurance_id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
              },
            },
          );
        }
        successCount++;
      } catch (error) {
        errors.push(
          `خطا در ${insurance.isNew ? "افزودن" : "ویرایش"} بیمه‌نامه با تاریخ ${insurance.expiry}: ${error.message}`,
        );
      }
    }

    return { successCount, errors };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const birthday = moment(inputs.birthday, "jYYYY/jM/jD").format("YYYY/MM/DD");
      const commonData = {
        authentication_id:
          selects.registrationType === "مورد تایید رئیس"
            ? null
            : inputs.membershipNumber,
        authentication_type:
          selects.registrationType === "مورد تایید رئیس" ? 1 : 0,
        city_id: selects.city,
        dewatering_to_evacuation_distance: inputs.distance || null,
        insured_livestock_count: inputs.insuredLiveStock || null,
        livestock_count: inputs.liveStock,
        mobiles: [{ mobile: inputs.mobile }],
        name: inputs.name,
        father_name: inputs.fatherName || null,
        request_tanker_days: inputs.requestTankerDays ?? null,
        national_code: inputs.code,
        population: inputs.family,
        region: inputs.nomadicArea,
        user_id: localStorage.getItem("userId"),
        water_type: inputs.waterType,
        water_storage_type:
          selects.tank === "تانکر" ? 0 : selects.tank === "آب انبار" ? 1 : 2,
        water_volume: inputs.waterVolume,
      };
      if (inputs.phone) {
        commonData.mobiles[1] = { mobile: inputs.phone };
      }

      const data = {
        ...commonData,
        birthday: birthday,
        created_at: new Date().toISOString(),
      };

      const result = await dispatch(
        addOrEditNomad({
          data,
          commonData,
          nomadId,
          dispatch,
          registerBtnType,
        }),
      ).unwrap();

      let finalNomadId = nomadId;
      if (result?.nomad_id) {
        finalNomadId = result.nomad_id;
        if (setNomadId) setNomadId(finalNomadId);
      }

      if (insurances.length > 0 && finalNomadId) {
        const { successCount, errors } = await sendInsurances(finalNomadId);
        if (errors.length === 0) {
          alert(`✅ همه ${successCount} بیمه‌نامه با موفقیت ثبت/ویرایش شدند`);
        } else {
          alert(
            `⚠️ ${successCount} بیمه‌نامه ثبت/ویرایش شد و ${errors.length} مورد خطا داشت:\n${errors.join("\n")}`,
          );
        }
      }
    } catch (error) {
      console.error(error);
      alert(`❌ خطا در ثبت اطلاعات: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const validateNumber = (event) => {
    if (event.ctrlKey || event.metaKey) return;
    const excludedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Delete"];
    if (
      !(
        (event.key >= "0" && event.key <= "9") ||
        excludedKeys.includes(event.key)
      )
    ) {
      event.preventDefault();
    }
  };

  useEffect(() => {
    if (showForm === false) {
      setInputs(initialInputState);
      setSelects(initialSelectsState);
      setInsurances([]);
    }
  }, [showForm]);

  return (
    <form className="add-applicant-form" onSubmit={handleSubmit}>
      <div
        className="grid grid-cols-[48%_48%] sm:grid-cols-[45%_45%] justify-between gap-y-3 py-5 [&>div]:relative [&>div]:flex
             [&>div]:gap-1 [&_input]:grow [&_input]:box-border [&_input]:input-styles [&_select]:box-border [&_select]:select-styles
              [&_select]:grow [&>select]:pr-0 [&_input]:text-[10px] sm:[&_input]:text-xs [&_select]:text-[10px] sm:[&_select]:text-xs
               [&_span]:text-red-600 focus:shadow-focusShadow [&_i]:input-hint-after-type"
      >
        <div>
          <input
            type="text"
            name="fatherName"
            value={inputs.fatherName}
            className="focus:shadow-focusShadow"
            placeholder="نام پدر"
            onChange={handleInputChange}
          />
          {inputs.fatherName !== "" && <i>نام پدر</i>}
        </div>
        <div>
          <input
            type="text"
            name="name"
            value={inputs.name}
            className="focus:shadow-focusShadow"
            placeholder="نام و نام خانوادگی"
            onChange={handleInputChange}
            required
          />
          {inputs.name !== "" && <i>نام</i>}
          <span>*</span>
        </div>
        <div className="relative [&_input]:absolute [&_input]:right-0 [&_input]:left-0">
          <DatePicker
            format="jYYYY/jMM/jDD"
            inputTextAlign="center"
            controlValue={true}
            preSelected={inputs.birthday}
            onChange={handleDateChange}
            customClass="datepicker w-full"
            placeholder={"تاریخ تولد"}
          />
          {inputs.birthday !== "" && <i>تاریخ تولد</i>}
        </div>
        <div>
          <input
            type="text"
            name="code"
            onKeyDown={validateNumber}
            pattern="[0-9]{10}"
            value={inputs.code}
            className="focus:shadow-focusShadow"
            placeholder="کد ملی(ده رقم)"
            onChange={handleInputChange}
            required
          />
          {inputs.code !== "" && <i>کد ملی</i>}
          <span>*</span>
        </div>
        <div>
          <input
            type="tel"
            name="phone"
            onKeyDown={validateNumber}
            pattern="09[0-9]{9}"
            value={inputs.phone}
            className="focus:shadow-focusShadow"
            placeholder="تلفن ضروری"
            onChange={handleInputChange}
          />
          {inputs.phone !== "" && <i>تلفن</i>}
        </div>
        <div>
          <input
            type="tel"
            name="mobile"
            onKeyDown={validateNumber}
            pattern="09[0-9]{9}"
            value={inputs.mobile}
            className="focus:shadow-focusShadow"
            placeholder="تلفن همراه"
            onChange={handleInputChange}
            required
          />
          {inputs.mobile !== "" && <i>همراه</i>}
          <span>*</span>
        </div>
        <div>
          <input
            type="text"
            name="distance"
            onKeyDown={validateNumber}
            value={inputs.distance}
            className="focus:shadow-focusShadow"
            placeholder="فاصله آبگیری تا تخلیه(کیلومتر)"
            onChange={handleInputChange}
          />
          {inputs.distance !== "" && <i>کیلومتر</i>}
        </div>
        <div>
          <input
            type="text"
            name="requestTankerDays"
            onKeyDown={validateNumber}
            value={inputs.requestTankerDays}
            className="focus:shadow-focusShadow"
            placeholder=" بازه زمانی ثبت درخواست"
            onChange={handleInputChange}
          />
          {inputs.requestTankerDays !== "" && (
            <i>(بازه زمانی ثبت درخواست)روز</i>
          )}
        </div>
        <div>
          <input
            type="text"
            name="family"
            onKeyDown={validateNumber}
            value={inputs.family}
            className="focus:shadow-focusShadow"
            placeholder="تعداد خانوار بهره مند"
            onChange={handleInputChange}
            required
          />
          {inputs.family !== "" && <i>خانوار</i>}
          <span>*</span>
        </div>
        <div className="relative">
          <select
            dir="rtl"
            name="province"
            onChange={handleSelectChange}
            className="focus:shadow-focusShadow"
            value={selects.province}
            required
          >
            <option disabled>انتخاب استان</option>
            <option value="خراسان جنوبی">خراسان جنوبی</option>
          </select>
          <span className="double-select-arrow right-4"></span>
          <span>*</span>
        </div>
        <div>
          <input
            type="text"
            name="liveStock"
            onKeyDown={validateNumber}
            value={inputs?.liveStock}
            placeholder="تعدا دام ها"
            className="focus:shadow-focusShadow"
            onChange={handleInputChange}
            required
          />
          {inputs.liveStock !== "" && <i>دام</i>}
          <span>*</span>
        </div>
        <div>
          <select
            dir="rtl"
            name="city"
            value={selects.city}
            className="focus:shadow-focusShadow"
            onChange={handleSelectChange}
            required
          >
            <option value="" disabled>
              انتخاب شهر
            </option>
            {allCities?.map((item, index) => {
              return (
                <option key={index} value={item.city_id}>
                  {item.name}
                </option>
              );
            })}
          </select>
          <span className="double-select-arrow right-4"></span>
          <span>*</span>
        </div>
        <div>
          <input
            type="text"
            name="insuredLiveStock"
            onKeyDown={validateNumber}
            value={inputs.insuredLiveStock}
            placeholder="تعداد دام بیمه شده"
            onChange={handleInputChange}
            className="!w-[calc(100%-10px)] !grow-0 focus:shadow-focusShadow"
          />
          {inputs.insuredLiveStock !== "" && <i>دام بیمه شده</i>}
        </div>
        <div className="relative">
          <select
            dir="rtl"
            name="tank"
            value={selects.tank}
            onChange={handleSelectChange}
            className="focus:shadow-focusShadow"
            required
          >
            <option value="" disabled>
              انتخاب نوع مخزن
            </option>
            <option value="تانکر">تانکر</option>
            <option value="آب انبار">آب انبار</option>
            <option value="استخر">استخر</option>
          </select>
          <span className="double-select-arrow right-4"></span>
          <span>*</span>
        </div>
        <div>
          <input
            type="text"
            name="nomadicArea"
            value={inputs.nomadicArea}
            className="focus:shadow-focusShadow"
            placeholder="منطقه عشایری"
            onChange={handleInputChange}
            required
          />
          {inputs.nomadicArea !== "" && <i>منطقه عشایری</i>}
          <span>*</span>
        </div>
        <div>
          <select
            dir="rtl"
            name="waterType"
            value={inputs.waterType}
            onChange={handleInputChange}
            className="select-styles focus:shadow-focusShadow"
          >
            <option value="" disabled>
              نوع آب درخواستی
            </option>
            <option value={1}>آب شرب</option>
            <option value={2}>آب دام</option>
                        <option value={3}>هر دو</option>

          </select>
          <span className="double-select-arrow right-4"></span>
          <span>*</span>
        </div>
        <div className="relative">
          <select
            dir="rtl"
            name="registrationType"
            value={selects.registrationType}
            className="focus:shadow-focusShadow"
            onChange={handleSelectChange}
            required
          >
            <option value="" disabled>
              انتخاب نوع ثبت نام
            </option>
            <option value="عضویت در تعاونی">عضویت در تعاونی</option>
            <option value="مورد تایید رئیس">مورد تایید رئیس</option>
          </select>
          <span className="double-select-arrow right-4"></span>
          <span>*</span>
        </div>
        <div>
          <input
            type="text"
            name="waterVolume"
            onKeyDown={validateNumber}
            value={inputs.waterVolume}
            className="focus:shadow-focusShadow"
            placeholder="حجم آب مورد تقاضا(لیتر)"
            onChange={handleInputChange}
            required
          />
          {inputs.waterVolume !== "" && <i>لیتر</i>}
          <span>*</span>
        </div>
        {selects?.registrationType === "عضویت در تعاونی" ? (
          <div className="col-start-2">
            <input
              type="text"
              name="membershipNumber"
              placeholder="شماره عضویت"
              onKeyDown={validateNumber}
              className="focus:shadow-focusShadow"
              value={inputs.membershipNumber}
              onChange={handleInputChange}
              required
            />
            {inputs.membershipNumber !== "" && <i>شماره عضویت</i>}
            <span>*</span>
          </div>
        ) : null}
      </div>

      <hr className="my-4 border-t-2 border-gray-300" />

      <div className="mb-4">
        <h3 className="text-md font-semibold mb-2">اطلاعات بیمه‌نامه دام</h3>
        {isLoadingInsurances ? (
          <p>در حال بارگذاری بیمه‌نامه‌ها...</p>
        ) : (
          <>
            {insurances.map((item) => {
              const key = item.id || item.insurance_id;
              return (
                <div
                  key={key}
                  className="grid grid-cols-[40%_40%_auto] gap-3 items-center mb-3 bg-gray-50 p-3 rounded"
                >
                  <div className="relative [&_input]:absolute [&_input]:right-0 [&_input]:left-0">
                    <DatePicker
                      format="jYYYY/jMM/jDD"
                      inputTextAlign="center"
                      controlValue={true}
                      preSelected={item.expiry}
                      onChange={(ts, newDate) =>
                        handleInsuranceDateChange(key, newDate)
                      }
                      customClass="datepicker w-full"
                      placeholder="تاریخ انقضای بیمه"
                    />
                    {item.expiry !== "" && <i>تاریخ انقضای بیمه</i>}
                  </div>
                  <div>
                    <input
                      type="file"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) handleInsuranceFileChange(key, file);
                      }}
                      className="file-input-styles focus:shadow-focusShadow w-full"
                    />
                    {item.file && (
                      <i className="text-green-600 text-xs">فایل انتخاب شد</i>
                    )}
                    {item.existingImage && !item.file && (
                      <i className="text-blue-600 text-xs">تصویر موجود</i>
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={() => removeInsurance(key)}
                    className="text-red-500 hover:text-red-700 font-bold text-lg"
                  >
                    ✕
                  </button>
                </div>
              );
            })}
          </>
        )}
        <button
          type="button"
          onClick={addInsurance}
          className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          disabled={isSubmitting || isLoadingInsurances}
        >
          + افزودن بیمه‌نامه
        </button>
      </div>

      <FormFooter isSubmitting={isSubmitting} />
    </form>
  );
};

export default AddApplicantForm;